import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, PLATFORM_ID, QueryList, ViewChildren, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AuthService } from '@services/auth.service';
import { SnackbarService } from '@services/snackbar.service';
import { NUMBER_REGEX } from '@shared/utils';
import { CountdownConfig, CountdownModule } from 'ngx-countdown';
interface ICountdown {
  action: string;
  left: number;
  status: number;
  text: string;
}
@Component({
  selector: 'app-phone-verify',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, CountdownModule, MatSnackBarModule],
  templateUrl: './phone-verify.component.html',
  styleUrl: './phone-verify.component.scss'

})


export class PhoneVerifyComponent implements OnInit, AfterViewInit {

  @Input() options: { isRegister: boolean, phone: string, user_id: string };
  @Output() registerSuccessEvent = new EventEmitter<any>();

  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);
  public isRegister: boolean;
  public phone: string;
  public user_id: string;
  public configTime: CountdownConfig = { leftTime: 120, format: 'mm:ss' };

  @ViewChildren('digitInput') digitInputs!: QueryList<ElementRef>;
  public phoneValidationForm = new UntypedFormGroup({
    phone: new UntypedFormControl('', [Validators.required, Validators.minLength(10), Validators.pattern(NUMBER_REGEX)]
    )
  });

  public loading = false;
  public code = '';
  public codeRetryAvailable = false;
  public verifyCodeStep = false;
  public canVerifyCode = false;
  public showInvalidCode = false;
  constructor(
    private authService: AuthService,
    private snackbarService: SnackbarService
  ) {

  }


  ngOnInit(): void {
    this.isRegister = this.options?.isRegister;
    this.phone = this.options?.phone ?? '';
    this.user_id = this.options?.user_id;
    if (this.isRegister) {
      this.configTime = { leftTime: 120, format: 'mm:ss' };
      this.verifyCodeStep = true;
      this.codeRetryAvailable = false;
    }
  }

  ngAfterViewInit(): void {
    if (this.digitInputs.first) {
      this.digitInputs.first.nativeElement.focus();
    }
  }

  removeError() {
    this.showInvalidCode = false;
  }

  moveToNext(event: any, index: number) {
    const inputElement = event.target as HTMLInputElement;
    if (event.key === 'Backspace' || event.key === 'Delete') {
      event.preventDefault();
      inputElement.value = '';
      this.updateNumericValue();
      return;
    }
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
      return;
    }
    if (/^[0-9]$/.test(event.key)) {
      inputElement.value = event.key;
      this.updateNumericValue();
      if (index < this.digitInputs.length - 1) {
        this.digitInputs.toArray()[index + 1].nativeElement.focus();
      }
      event.preventDefault();
      return;
    }
    this.updateNumericValue();
  }

  updateNumericValue() {
    this.code = this.digitInputs.toArray().map(input => input.nativeElement.value).join('');
    if (this.code?.length === 6) {
      this.canVerifyCode = true;
    } else {
      this.canVerifyCode = false;
      this.showInvalidCode = false;
    }
  }

  public async verifyCode() {
    try {
      this.loading = true;
      const { data } = await this.authService.verifyCodeAndUpdateCellphone(this.phone, this.code, this.user_id);
      this.loading = false;
      if (data.message === 'Cellphone successfully updated.') {
        if (this.isBrowser) window.location.reload();
      }
    } catch (error) {
      this.showInvalidCode = true;
      this.loading = false;
    }
  }

  public async editNumber() {
    this.verifyCodeStep = false;
    this.loading = false;
    this.code = '';
    this.showInvalidCode = false;
  }


  public handleCountdownEvent(e: ICountdown): void {
    if (e.action === 'done') {
      this.codeRetryAvailable = true;
    }
  }

  public async getCode() {
    try {
      this.phone = this.phoneValidationForm.get('phone')?.value;
      this.loading = true;
      await this.authService.updateCellphone(this.phone);
      this.snackbarService.openSnackbar('Código enviado', 'advice');
      this.configTime = { leftTime: 120, format: 'mm:ss' };
      this.verifyCodeStep = true;
      this.codeRetryAvailable = false;
      this.loading = false;
    } catch (error: any) {
      this.loading = false;
      if (error?.error?.data?.message === 'Cellphone not exists or it\'s already verified.') {
        this.phoneValidationForm?.get('phone')?.setErrors({ alreadyExists: true });
      } else {
        this.phoneValidationForm?.get('phone')?.setErrors({ error: true });
      }
    }
  }


  public async verifyCodeRegister() {
    try {
      this.loading = true;
      const { data } = await this.authService.verifyCodeClient(this.user_id, { cellphone: this.phone, code: this.code });
      this.loading = false;
      if (data[0].message === 'approved') {
        this.registerSuccessEvent.emit(data[0]);
      } else {
        throw new Error('Error al registrar');
      }
    } catch (error) {
      this.showInvalidCode = true;
      this.loading = false;
    }
  }

  public async getCodeRegister() {
    try {
      this.loading = true;
      const response = await this.authService.resendVerificationCode(this.phone, this.user_id);
      if (response.code === 200) {
        this.configTime = { leftTime: 120, format: 'mm:ss' };
        this.snackbarService.openSnackbar('Código enviado', 'advice');
        this.codeRetryAvailable = false;
        this.verifyCodeStep = true;
        this.loading = false;
      } else {
        throw new Error('Error al enviar el código');
      }
    } catch (error: any) {
      this.loading = false;
      this.phoneValidationForm?.get('phone')?.setErrors({ error: true });
    }
  }

}
